import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgTelegramSolid = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 25 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M2 8.957c0-2.435 0-3.653.474-4.583a4.35 4.35 0 0 1 1.9-1.9C5.304 2 6.522 2 8.957 2h6.086c2.436 0 3.653 0 4.583.474a4.35 4.35 0 0 1 1.9 1.9C22 5.304 22 6.522 22 8.957v6.086c0 2.436 0 3.653-.474 4.583a4.35 4.35 0 0 1-1.9 1.9c-.93.474-2.148.474-4.583.474H8.958c-2.435 0-3.653 0-4.583-.474a4.35 4.35 0 0 1-1.9-1.9C2 18.696 2 17.478 2 15.043z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M6.527 11.895Q10.9 9.99 12.358 9.382c2.778-1.155 3.355-1.355 3.73-1.362.083-.001.268.02.388.116a.42.42 0 0 1 .143.271c.013.078.03.255.016.394-.15 1.581-.802 5.418-1.133 7.19-.14.749-.416 1-.683 1.025-.58.053-1.022-.384-1.584-.753-.88-.577-1.378-.936-2.232-1.499-.987-.65-.347-1.008.215-1.593.148-.153 2.706-2.48 2.756-2.691.006-.026.012-.125-.047-.177s-.144-.034-.207-.02q-.132.03-4.218 2.788-.598.411-1.084.4c-.357-.007-1.044-.201-1.555-.367-.626-.204-1.124-.311-1.08-.657q.033-.27.744-.552"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgTelegramSolid;
